import { z } from 'zod'

// result of the merged link-and-import flow: the id of the freshly-linked regular Account and the
// number of historical payouts promoted to Income during the same request.
export const linkAndImportResponseSchema = z.object({
  accountId: z.string(),
  importedCount: z.number(),
})

export type LinkAndImportResponseDto = z.infer<typeof linkAndImportResponseSchema>
